var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextLinkList',{attrs:{"href":"/","text":"テキストリンクリスト（下線無し）"}}),_vm._v(" "),_c('TextLinkList',{attrs:{"href":"/","text":"テキストリンクリスト","border":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }